import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "Configuración de equipo",
    modelValue: _ctx.dialogTeamColor,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogTeamColor) = $event)),
    class: "bg-light dg-custom w-500px",
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, null, 8, ["modelValue"]))
}